<template>
	<el-card class="box-card">
		<template #header>
			<div class="card-header">
				<span>分类促销设置</span>
				<el-button class="button" @click='edit("")' type="success">新增促销分类</el-button>
			</div>
		</template>
		<div class="col">
	 		<el-table v-loading="loading" @expand-change="open_expand" ref="tables" :header-cell-style="{'text-align':'center'}" :cell-style="{'text-align':'center'}" empty-text="暂无数据" :data="list.filter(data => !search || data.promotion_name.toLowerCase().includes(search.toLowerCase()))"
	 		 style="width: 100%;" :default-sort="sort" border highlight-current-row>
				<el-table-column type="expand">
					<template #default="scope">
						<el-form label-position="left" inline class="demo-table-expand">
							<el-form-item label="促销分类">
								<el-tree :props="props" :data="scope.row.category_list_all"></el-tree>
							</el-form-item>
						</el-form>
					</template>
				</el-table-column>
	 			<el-table-column prop="promotion_name" label="促销名称"></el-table-column>
				<el-table-column prop="promotion_deduction_value" label="促销减价"></el-table-column>
				<el-table-column prop="promotion_date_start" label="开始时间">
					<template #default='scope'>
						{{timestampToTime(scope.row.promotion_date_start)}}
					</template>
				</el-table-column>
				<el-table-column prop="promotion_date_end" label="结束时间">
					<template #default='scope'>
						{{timestampToTime(scope.row.promotion_date_end)}}
					</template>
				</el-table-column>
	 			<el-table-column align="right">
	 				<template #header>
	 					<el-input v-model="search" size="medium" placeholder="输入商品类型名称" />
	 				</template>
	 				<template #default="scope">
	 					<el-button type="primary" size="medium" @click="edit(scope.row)">编辑</el-button>
	 					<el-button type="danger" size="medium" @click="destroy(scope.$index, scope.row)">删除</el-button>
	 				</template>
	 			</el-table-column>
	 		</el-table>
	 	</div>
	</el-card>
	<el-dialog :title="title" v-model="dialogFormVisible">
		<el-form label-position='left' :model="item" ref="form" :rules="rules">
			<el-form-item>
				<el-row :gutter="20">
					<el-col :span="3">
						<label>促销名称</label>
					</el-col>
					<el-col :span="10">
						<el-form-item prop="promotion_name">
							<el-input v-model="item.promotion_name"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
			</el-form-item>
			<el-form-item>
				<el-row :gutter="20">
					<el-col :span="3">
						<label>促销比例</label>
					</el-col>
					<el-col :span="10">
						<el-form-item prop="promotion_deduction_value">
							<el-input clearable style='width: 150px;' size="medium" v-model="item.promotion_deduction_value" placeholder="模板(%OFF)--20.0000" autocomplete="off"></el-input>
							<span style="margin-left: 20px;">{{item.promotion_deduction_value}}%off</span>
						</el-form-item>
					</el-col>
				</el-row>
			</el-form-item>
			<el-form-item>
				<el-row :gutter="20">
					<el-col :span="3">
						<label>类别</label>
					</el-col>
					<el-col :span="15">
						<el-form-item prop="list_category_id">
							<el-tree node-key="id" v-model="item.list_category_id" @check="tree_change" show-checkbox :data="tree"
							 :props="props" ref="treeData"></el-tree>
						</el-form-item>
					</el-col>
				</el-row>
			</el-form-item>
			<el-form-item>
				<el-row :gutter="20">
					<el-col :span="3">
						<label>活动期限</label>
					</el-col>
					<el-col :span="5">
						<el-form-item prop="promotion_date_start">
							<el-input v-model="item.promotion_date_start" type="date" placeholder="开始时间" autocomplete="off"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="5">
						<el-form-item prop="promotion_date_end">
							<el-input v-model="item.promotion_date_end" type="date" placeholder="结束时间" autocomplete="off"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
			</el-form-item>
		</el-form>
		<div slot="footer" class="dialog-footer">
			<el-button @click="dialogFormVisible = false">取 消</el-button>
			<el-button type="primary" @click="submit()">确 定</el-button>
		</div>
	</el-dialog>
</template>

<script>
	export default {
		name: 'CategoryPromotion',
		components: {},
		data() {
			return {
				title: '新增促销',
				dialogFormVisible: false,
				loading: true,
				list: [], //全部数据
				tree: [], //总分类
				search: '',
				sort: {
					prop: 'id',
					order: 'descending'
				},
				props: {
					label: 'name',
					children: 'son'
				},
				item: {
					promotion_name: '',
					promotion_deduction_value: 0,
					promotion_date_start: '',
					promotion_date_end: '',
					list_category_id: [], //新增促销  分类id
				},
				rules: {
					promotion_name: [{
						required: true,
						message: '请填写名称',
						trigger: 'blur'
					}],
					promotion_deduction_value: [{
						required: true,
						message: '请填写促销比例',
						trigger: 'blur'
					}],
					promotion_date_start: [{
						required: true,
						message: '请选择时间',
						trigger: 'blur'
					}],
					promotion_date_end: [{
						required: true,
						message: '请选择时间',
						trigger: 'blur'
					}],
					list_category_id: [{
						type: 'array',
						required: true,
						message: '请至少选择一个分类',
						trigger: 'click'
					}],
				},

			}
		},
		methods: {
			//对table 表格进行展开或关闭方法 开始
            open_expand(row, list) {
                // console.log(list);
                // console.log(list);
                // this.$refs.tables.toggleRowExpansion(row, false);
                // console.log($event);
                // console.log(expandedRows);
                // console.log(row.sale_name);
                for (let i in list) {
                    if (this.looseEqual(list[i],row)) {
                        this.$refs.tables.toggleRowExpansion(row, true);
                    } else {
                        this.$refs.tables.toggleRowExpansion(list[i], false);
                    }

                }
            },
            isObject(obj) {
                return obj !== null && typeof obj === 'object'
            },
            looseEqual(a, b) {
                if (a === b) return true
                const isObjectA = this.isObject(a)
                const isObjectB = this.isObject(b)
                if (isObjectA && isObjectB) {
                    try {
                        const isArrayA = Array.isArray(a)
                        const isArrayB = Array.isArray(b)
                        if (isArrayA && isArrayB) {
                            return a.length === b.length && a.every((e, i) => {
                                return this.looseEqual(e, b[i])
                            })
                        } else if (!isArrayA && !isArrayB) {
                            const keysA = Object.keys(a)
                            const keysB = Object.keys(b)
                            return keysA.length === keysB.length && keysA.every(key => {
                                return this.looseEqual(a[key], b[key])
                            })
                        } else {
                            return false
                        }
                    } catch (e) {
                        return false
                    }
                } else if (!isObjectA && !isObjectB) {
                    return String(a) === String(b)
                } else {
                    return false
                }
            },
            //对table 表格进行展开或关闭方法 结束
			edit(row) {
				let temp = this.cloneObj(row);
				console.log(temp)
				if (row) {
					this.title = '编辑分类促销';
					this.item = temp;
					this.$nextTick(function() {
						this.item.promotion_date_start = this.timestampToTime(temp.promotion_date_start);
						this.item.promotion_date_end = this.timestampToTime(temp.promotion_date_end);
						this.$refs.treeData.setCheckedKeys([]);//关闭模态框时 取消上一次选中的分类
						this.item.list_category_id.forEach((value)=>{
	//1. 勾选节点的 key 或者 data 2. boolean 类型，节点是否选中 3. boolean 类型，是否设置子节点 ，默认为 false）如果全部选中setCheckedKeys
	//                         console.log(value)
								this.$refs.treeData.setChecked(value,true,false);
							})
					});
					this.item.list_category_id=temp.list_category_id.split(','); //点击复选框 将id 传入数组
					
				} else {
					this.title = '新增分类促销';
					if(this.$refs.treeData){
						this.$refs.treeData.setCheckedKeys([]);//关闭模态框时 取消上一次选中的分类  一定要在resetObj 之前
					}
					this.resetObj(this.item)
					
				}
				this.dialogFormVisible = true;

				this.$nextTick(() => {
					this.$refs['form'].clearValidate();
				})
			},
			tree_change(data,status){
                this.item.list_category_id=[];//每次点击 清空上一次复选框
                let rad=''
                let ridsa = this.$refs.treeData.getCheckedKeys().join(',')// 获取当前的选中的categories_id  逗号拼接   不包含半勾选状态父id
                // console.log(ridsa);
                let ridsb = this.$refs.treeData.getCheckedNodes()// 获取当前的选中的数据{对象}  当前选中的分类信息
                // console.log(ridsb);
                ridsb.forEach(ids=>{//获取选中的所有的父级id
                    rad+=','+ids.pid
                })
                rad=rad.substr(1) // 删除字符串前面的','
                let rids=rad+','+ridsa
                let arr=rids.split(',')//  把字符串转换成数组
                arr=[...new Set(arr)]; // 数组去重
                // console.log(arr);
                for (let i in arr){
                    if(arr[i]!=0){
                        this.item.list_category_id.push(arr[i]); //点击复选框 将id 传入数组
                    }
                }
                console.log(this.item.list_category_id);
            },
			destroy(index, row) {
				// console.log(index, row)
				// return false;
				let id = row.id
				this.msgBoxAjax('警告', '确定删除吗?', '/admin/promotion/categoryPromotionDelete', {
					id: id
				}).then((re) => {
					if (re.code > 1) return this.$message.error(re.msg)
					this.getCategoryDiscount();
				})
			},
			getCategoryAll(){
				//展示全部分类
					this.httpPost({
						url: '/admin/category/categoryList'
					}).then((re) => {
						let data = re.data
						console.log(data)
						let temp = this.cloneObj(data);
						this.tree = temp;
								
					}).catch((err) => {})
            },
			 //展示分类促销以及促销选中的分类
            getCategoryDiscount(){
				// return false;
				this.httpPost({
					url: '/admin/promotion/categoryPromotionList',
					data: {
						routePath: this.$route.path
					}
				}).then((re) => {
					let data = re.data
					console.log(data)
					let temp = this.cloneObj(data);
					this.list= temp;
					this.loading = false;
				}).catch((err) => {})
            },
			submit() {
				console.log(this.item);
				this.$refs['form'].validate((valid) => {
					if (valid) {
						this.httpPost({
							url: '/admin/promotion/categoryPromotionUpdate',
							data: this.item
						}).then((re) => {
							// console.log(re);
							this.dialogFormVisible = false;
							this.resetObj(this.item)
							this.getCategoryDiscount();
						})
			
					} else {
						console.log('error submit!!');
						return false;
					}
				})
			
			},

		},
		created() {
			this.getCategoryDiscount();
			this.getCategoryAll();
		}
	}
</script>

<style>
	.demo-table-expand {
		font-size: 0;
	}

	.demo-table-expand label {
		width: 90px;
		color: #99a9bf;
	}

	.demo-table-expand .el-form-item {
		margin-right: 0;
		margin-bottom: 0;
		width: 50%;
	}
</style>
